import { useEffect, useReducer, useState } from "react";
import { Container } from "@sainsburys-tech/luna-grid";
import { Pagination } from "@sainsburys-tech/luna-pagination";
import { saveAs } from "file-saver";
import { ButtonGroupPrimary, OutlinedButton } from "@sainsburys-tech/luna-button";
import {
  errorToast,
  successToast,
} from "../../../../Service-Utils/toastMessage";
import * as CONSTANTS from "../../../../Constants/index";
import {
  initialState,
  reducer,
} from "../../../../Redux/Reducers/paginationReducer";
import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";
import { useGetApi } from "../../../../Redux/Hooks/useGetApi";
import EditableGridLuna from "../../../SharedComponents/EditableTable";
import { usePostApiRequest } from "../../../../Redux/Hooks/usePostApi";
import CustomToast from "../../../SharedComponents/CustomToast";
import LoadingIndicator from "../../../Loading";
import { IRequestParams } from "../../../../Interfaces/IRequestParams";
import { FilterTypeForFamilyGroupAdmin } from "../../../../Types/filterTypeForFamilyGroupAdminType";
import { decoratePayloadAndEndPoint } from "./decoratePayloadAndEndPointHelper";
import { useSelector } from "react-redux";
import ConfirmPopup from "../../ConfirmModalPopup/confirmModalPopup";
import { filterModelSelecterAndProcessData } from "../../../../helpers/filterModelSelector";
import store from "../../../../Store/store";
import { ValuesType } from "../../../../Types/InitialStateType";
import { familyGroupSearchPayload } from "../../../../Redux/Actions/searchAction";
import { setResponseMessage } from "../../../../helpers/messageHelper";
import { storeFilter } from "../../../../Redux/Actions/filterActions";
import { filterPayloadType } from "../../../../Types/filterPayloadType";
import { emptyEditTablePayload } from "../../../../Redux/Actions/editTableActions";
import { consolelog } from "../../../../helpers/consolelog";

const DataTable = (props: FilterTypeForFamilyGroupAdmin) => {
  const [isError, setIsError] = useState(false);
  const [message, setMessage] = useState<string>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [enableDownload, setEnableDownload] = useState(false);
  const [responseData, setResponseData] = useState();
  const [operationType, setOperationType] = useState<string>();
  const [{ queryPageIndex, skip, queryPageSize, totalCount }, dispatch] =
    useReducer(reducer, initialState);
  const {
    data: filter,
    isDirectQuery,
    parentName,
    selectedMenu,
    createPopupName,
    deletePopupName,
    searchPageReset,
  } = useSelector((state: any) => state.filterReducer.data);
  const payload = useSelector((state: any) => state.popupReducer.data);
  //For file download
  const downloadParams: IRequestParams = {
    service: endpoints.downloadFamilyGroup(),
    skip: 0,
    take: 0,
    isEnabled: enableDownload,
    filter: filter,
    key: ``,
    isPaginationRequired: false,
    refetchOnWindowFocus: false,
    responseType: "blob",
    onError(error: any) {
      onError(error);
    },
    onSuccess(result: any) {
      onSuccess(result);
    },
  };

  let params = {
    service: props.service,
    skip: skip,
    take: queryPageSize,
    isEnabled: true,
    filter: filter,
    refetchOnWindowFocus: false,
    isPaginationRequired: props.isPaginationRequired,
    key: ``,
    onError(error: any) {
      onError(error);
    },
    onSuccess(result: any) {
      onSuccess(result);
    },
  };

  const { data: downloadApiResponse, isLoading: isDownLoading } =
    useGetApi(downloadParams);
  //For file download

  //For update
  const paramsPorPost = {
    onSuccess(result: any) {
      onSuccess(result);
    },
    onError(error: any) {
      onError(error);
      setOperationType("");
    },
  };
  const {
    mutate,
    isLoading: isMutateLoading,
    isSuccess: isMutateSuccess,
  } = usePostApiRequest(paramsPorPost);

  useEffect(() => {
    let headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    //For Add
    if (
      payload !== null &&
      payload !== undefined &&
      payload.addPayload !== null &&
      payload.addPayload !== undefined
    ) {
      let requestPayload = {
        familyGroup: payload.addPayload.familyGroup,
        familyGroupDescription: payload.addPayload.familyGroupDescription,
        productType: payload.addPayload.productType,
        LPFamilyGroupMix: payload.addPayload?.LPFamilyGroupMix,
        MLPFamilyGroupMix: payload.addPayload?.MLPFamilyGroupMix,
        SerialControl: payload.addPayload?.SerialControl,
        SerialInputMask: payload.addPayload?.SerialInputMask,
        StrapTotes: payload.addPayload.StrapTotes
      };
      const params = {
        service: endpoints.familyGroup(),
        method: "post",
        payload: requestPayload,
        headers: headers,
      };
      mutate(params);
      store.dispatch(emptyEditTablePayload());
      setOperationType("CreateFamilyGroup");
      payload.addPayload = null;
    }
    //For Delete
    if (
      payload !== null &&
      payload !== undefined &&
      payload.deletePayload !== null &&
      payload.deletePayload !== undefined
    ) {
      const params = {
        service: endpoints.deleteFamilyGroup(payload.deletePayload),
        method: "delete",
        payload: null,
        headers: headers,
      };
      mutate(params);
      store.dispatch(emptyEditTablePayload());
      setOperationType("DeleteFamilyGroup");
      payload.deletePayload = null;
    }
    // For Edit
    // if (isMutateSuccess && payload === null) {
    //     setMessage("Family Group updated successfully")
    // }

    if (isMutateSuccess && !isError && operationType !== "") {
      successToast(setResponseMessage(operationType));
      setOperationType("");
      refetch();
    }
  }, [payload, isMutateSuccess, message, isError, operationType]);

  //For Download file
  useEffect(() => {
    if (
      !isDownLoading &&
      downloadApiResponse !== undefined &&
      enableDownload &&
      !isError
    ) {
      let url = window.URL.createObjectURL(
        new Blob([downloadApiResponse?.data])
      );
      saveAs(url, "FamilyGroup.xlsx");
    }
    setEnableDownload(false);
  }, [downloadApiResponse, isDownLoading]);

  const onSave = (editableData: any) => {
    const { payload, headers, endPoint, method } = decoratePayloadAndEndPoint(
      editableData,
      selectedMenu
    );
    props.toggleSearchPanel(false);
    const params = {
      service: endPoint,
      method: method,
      payload: payload,
      headers: headers,
    };
    mutate(params);
    setOperationType("EditFamilyGroup");
    store.dispatch(emptyEditTablePayload());
  };

  const onDelete = (editableData: any) => {
    let data: ValuesType[] = [
      {
        data: editableData,
        name: "",
        label: "",
        value: "",
        searchMethod: "contains",
        searchOperator: "and",
      },
    ];

    const filter = filterModelSelecterAndProcessData(data, "SearchFamilyGoup");
    let filterPayload = {
      data: filter,
    };
    store.dispatch(
      familyGroupSearchPayload({
        filter: filterPayload,
        rowToBeDelete: editableData,
      })
    );
    setIsModalOpen(true);
  };

  const onEdit = (isPanelVisible: boolean) => {
    props.toggleSearchPanel(isPanelVisible);
  };
  const onSuccess = (data: any) => {
    if (data.isAxiosError) {
      errorToast(data.message);
      setIsError(true);
      setOperationType("");
    } else if (data.status === 200 || data.status === 204) {
      setIsError(false);
    } else {
      setIsError(false);
    }
  };

  const onError = (error: any) => {
    consolelog("onError callback", error);
  };

  const {
    data: apiResponse,
    isLoading,
    refetch,
    isSuccess,
  } = useGetApi(params);

  useEffect(() => {
    isSuccess && refetch();
  }, [isSuccess]);

  useEffect(() => {
    //let ispageIndex = searchPageReset
    if (
      searchPageReset === "searchQueryPageReset" ||
      searchPageReset === "fullPageReset"
    ) {
      if (apiResponse?.data?.["@odata.count"] > 0) {
        dispatch({
          type: CONSTANTS.SEARCH_PAGE_RESET,
          payload: apiResponse?.data["@odata.count"],
        });
        let filterPayload: filterPayloadType = {
          data: searchPageReset === "fullPageReset" ? "" : filter,
          isDirectQuery: true,
          codeScreen: "FamilyGroupDataTable 218",
          selectedMenu: selectedMenu,
          parentName: parentName,
          createPopupName,
          deletePopupName,
          searchPageReset: "",
          description: undefined,
          nestedSearchId: undefined,
          previousParentName: undefined,
          previousQueryData: undefined,
          searchId: undefined,
        };
        store.dispatch(storeFilter(filterPayload));
      }
    } else {
      if (apiResponse?.data?.["@odata.count"] > 0) {
        dispatch({
          type: CONSTANTS.TOTAL_COUNT_CHANGED,
          payload: apiResponse?.data["@odata.count"],
        });
      }
    }
  }, [apiResponse?.data?.["@odata.count"]]);

  function modifiyDescription(item: any, index: any, arr: any) {
    item.FamilyGroupWithDescription = `${item.FamilyGroup}`;
    arr[index] = item;
  }

  useEffect(() => {
    if (props.isColumnMerge) {
      if (apiResponse?.data?.["@odata.count"] > 0) {
        apiResponse?.data?.value.forEach(modifiyDescription);
      }
    }
  }, [
    apiResponse?.data?.value,
    props.isColumnMerge,
    apiResponse?.data?.["@odata.count"],
  ]);

  const errorMsg = (msg?: any) => {
    if (!isLoading) {
      consolelog("Error:", msg);
      return <div style={{ color: "red" }}>{msg}</div>;
    }
    return "";
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      {!isLoading && apiResponse?.data?.value ? (
        <>
          <EditableGridLuna
            data={apiResponse?.data?.value}
            columnDeffs={props.columnDefinition}
            rowKey="Category,FamilyGroup,Company,"
            tableName="FamilyGroupAdmin"
            onSave={onSave}
            onEdit={onEdit}
            onDelete={onDelete}
            isSortable={false}
          />
          {apiResponse?.data?.["@odata.count"] > 0 ? (
            <>
              <hr />
              <Container>
                {/* Hiding download button for now as file related functionality not available  */}
                {/* <div style={{ float: "left" }}>
                  <ButtonGroupPrimary className="">
                    <OutlinedButton
                      className="ln-u-margin-right"
                      type="button"
                      onClick={(event: any) => {
                        setEnableDownload(true);
                      }}
                    >
                      Download File
                    </OutlinedButton>
                  </ButtonGroupPrimary>
                </div> */}

                <div style={{ float: "right" }}>
                  <Pagination
                    showFirstAndLast
                    current={queryPageIndex}
                    total={Math.ceil(totalCount / queryPageSize)}
                    onChange={(page: any, e: any) => {
                      e.preventDefault();
                      dispatch({ type: CONSTANTS.PAGE_CHANGED, payload: page });
                    }}
                    createHref={(page: any) => `/${page}`}
                  />
                </div>
              </Container>
              <hr />
              <Container className="marginTop4"> </Container>
              <hr />
            </>
          ) : (
            <>{!isError && errorMsg(CONSTANTS.ERROR_MESSAGES.noRecordsFound)}</>
          )}
        </>
      ) : (
        errorMsg()
      )}
      {(isLoading || isDownLoading || isMutateLoading) && <LoadingIndicator />}
      <CustomToast />

      {isModalOpen && deletePopupName === "familyGroupDeleteManagement" && (
        <ConfirmPopup
          isOpen={isModalOpen}
          title={"Delete"}
          handleClose={handleClose}
          Id={""}
        />
      )}
    </>
  );
};

export default DataTable;
